import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { jsx, jsxs } from 'react/jsx-runtime.js';
import React__default from 'react';
import { v4 } from 'uuid';

var _excluded = ["search", "line", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var HighlightSearch = function HighlightSearch(props) {
  var search = props.search,
    line = props.line,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    restProps = _objectWithoutProperties(props, _excluded);
  if (line && search && search !== '') {
    var regexp = new RegExp(search, 'gi');
    var arr = line.split(regexp);
    if (arr.length === 1) {
      return jsx("span", _objectSpread(_objectSpread({}, restProps), {}, {
        className: className,
        children: line
      }));
    }
    var lastStr = arr.pop();
    return jsxs("span", _objectSpread(_objectSpread({}, restProps), {}, {
      className: className,
      children: [arr.map(function (item) {
        return jsxs("span", {
          children: [item, jsx("em", {
            style: {
              background: "rgba(75, 155, 230, 0.2)",
              fontStyle: 'normal'
            },
            children: regexp.exec(line)[0]
          })]
        }, v4());
      }), lastStr]
    }));
  }
  return jsx("span", _objectSpread(_objectSpread({}, restProps), {}, {
    className: className,
    children: line
  }));
};
var MemoizedHighlightSearch = /*#__PURE__*/React__default.memo(HighlightSearch);

export { MemoizedHighlightSearch as HighlightSearch };
